<div class="container">
  <div class="title-section font-17 black-color">
    <p>Payment Options</p>
  </div>
  <div>
    <p class="grey-color font-14">
      You may added a maximum number of 9 cards to your profile as a payment
      method.
    </p>
  </div>
  <mat-grid-list [cols]="breakpoint" rowHeight="190px" [gutterSize]="'10px'">
    <mat-grid-tile *ngFor="let paymentCard of paymentOptions; index as i; trackBy: trackByPaymentMethod">
      <div (click)="controlChange(i)" class="main-container" role="button" tabindex="0" aria-label="Select option" (keydown.enter)="controlChange(i)" (keydown.space)="$event.preventDefault(); controlChange(i)">
        <app-gdo-payment-card [paymentCard]="paymentCard" [i]="i" [defaultPaymentMethodNo]="defaultPaymentMethodNo"
          [paymentOptions]="paymentOptions" (cardDefault)="defaultCard($event)"
          (cardDelete)="deleteCard($event)"></app-gdo-payment-card>
      </div>
    </mat-grid-tile>
    <mat-grid-tile class="tile-add-payment" *ngIf="allowAddPaymentMethod">
      <div class="main-container add-new-card"(click)="addCard()"  role="button" tabindex="0" aria-label="Add payment method" (keydown.enter)="addCard()" (keydown.space)="$event.preventDefault(); addCard()">
        <button mat-fab color="red" class=" {{isWebView?'mat-fab-wv':'mat-fab'}}" (click)="addCard()">
          <mat-icon>add</mat-icon>
        </button>
        <div class="add-new-payment-margin" >
          <button style="background: none; border: none; cursor: pointer;" (click)="addCard()">
            <p class="red-color font-16">Add New Payment Option</p>
          </button>
        </div>
      </div>
    </mat-grid-tile>
  </mat-grid-list>
</div>
